import isArray from 'lodash/isArray'
import get from 'lodash/get'

export default {
	hasGamified : (state, getters, rootState, rootGetters) => {
		return rootGetters.hasFeature('gamified-wheel-element')
	},
	typePermitted : (state, getters) => (type) => {
		if ('gamified' === type) {
			return getters.hasGamified
		}
		return state.permittedTypes.includes(type)
	},
	validType : (state) => {
		return Boolean(get(state.types, state.activeType, false))
	},
	featured : (state) => {
		const filtered = state.templates.filter((template) => {
			return template.tags.find(t => 'Featured' === t.name)
		})

		const featured = {}
		Object.keys(state.types).forEach((type) => {
			featured[type] = []
		})

		filtered.forEach((template) => {
			featured[template.type].push(template)
		})

		return featured
	},
	filterGamified : (state) => {
		return 'gamified' === state.activeType
	},
	filters : (state, getters) => {
		const filters = {}

		Object.keys(state.filters).forEach(filter => {
			filters[filter] = isArray(state.filters[filter])
				? [ ...state.filters[filter] ]
				: state.filters[filter]
		})

		if (getters.filterGamified) {
			if (!filters.tags.includes(1)) {
				filters.tags.push(1)
			}
		}

		return filters
	},
	typeNames : (state) => {
		let allowed = {}

		Object.keys(state.types).forEach(type => {
			allowed[ type ] = state.types[ type ].name
		})

		return allowed
	},
	typeCount : (state, getters) => {
		return Object.keys(getters.typeNames).length
	},
}
